import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { Search } from "../Component/UI/Search";
import { Calender } from "../Component/UI/Calender";
import { Filter } from "../Component/UI/Filter/Filter";
import { Exports } from "../Component/UI/Export/Export";
import CustomizedButtons from "../Component/UI/Button/CustomizeButton";

import { Link } from "react-router-dom";
import { TEXT } from "../Samvenda-Admin/contant/constant";
import SimpleBreadcrum from "../Component/UI/SimpleBreadcrum";
import { MonthPicker } from "../Samvenda-Admin/UI/monthPicker/MonthPicker";
import { Btn } from "../Samvenda-Patient/UI/Button";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

export const SimpleHeader = ({
  text,
  children,
  route = "",
  basic,
  noPaddingTop,
  links,
  btnText,
  select,
  editStaffName,
  roles,
  saveRolesAndPerms,
  rosterPermissions,
  isLoadingSave,
  rolesAndPerms,
  styles,
  csvButtonText,
  downloadCSV,
  isDownloading
}) => {
  const navigate = useNavigate();

  const writePermissions = +rosterPermissions?.access?.Write;
  const writePermissionsRol = +rolesAndPerms?.access?.Write;

  return (
    <>
      <Grid
        container
        sx={{
          background: "#fff",
          borderRadius: "18px",
          boxShadow: "0px 4px 18px rgba(0,0,0,0.06)",
          padding: "22px 28px",
          marginBottom: "24px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Left Side */}
        <Grid item>
          <SimpleBreadcrum
            link={links}
            editStaffName={editStaffName}
            text={text}
          />
        </Grid>

        {/* Right Side */}
     {/* Right Side */}
<Grid
  item
  sx={{
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  }}
>
  {/* Group 1 : Date + Download CSV */}
  <Grid
    sx={{
      display: "flex",
      alignItems: "flex-end",
      gap: 2,
      mr: 8, // Space between the two groups
    }}
  >
    {csvButtonText && (
      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
      

        <Calender width="240px" />
      </Grid>
    )}

    {csvButtonText && (
     <Btn
  bgColor="#00B091"
  width="170px"
  height="40px"
  variant="contained"
  borderRadius="12px"
  disabled={isDownloading}
  click={() => downloadCSV()}
>
  {isDownloading ? (
    <CircularProgress size={18} color="inherit" />
  ) : (
    csvButtonText
  )}
</Btn>
    )}
  </Grid>

  {/* Group 2 : Month + Add */}
  <Grid
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
    }}
  >
    {!roles && (
      <MonthPicker
        disabled={
          text === "Edit Roster" || text === "Add Roster"
        }
      />
    )}

    {btnText === "Add" ? (
      writePermissions ? (
        <Btn
          bgColor="#00B091"
          width="90px"
          height="40px"
          variant="contained"
          borderRadius="12px"
          click={() => navigate("add")}
        >
          {btnText}
        </Btn>
      ) : null
    ) : (
      roles &&
      (writePermissionsRol ? (
        <Btn
          bgColor="#00B091"
          width="120px"
          height="46px"
          variant="contained"
          borderRadius="12px"
          disabled={isLoadingSave}
          click={saveRolesAndPerms}
        >
          {isLoadingSave ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            btnText
          )}
        </Btn>
      ) : null)
    )}
  </Grid>
</Grid>
      </Grid>

      {children}
    </>
  );
};